import { Box, Button, Stack, Typography } from "@mui/material";
import { Plus, RefreshCw, Warehouse } from "lucide-react";
import DataExportButton from "../../components/DataExportButton";
import { OperationFilters } from "../types";

interface OperationsHeaderProps {
  loading: boolean;
  canCreate: boolean;
  onRefresh: () => void;
  onCreate: () => void;
  filters: OperationFilters;
}

const OperationsHeader = ({ loading, canCreate, onRefresh, onCreate, filters }: OperationsHeaderProps) => (
  <Stack
    direction={{ xs: "column", md: "row" }}
    justifyContent="space-between"
    alignItems={{ xs: "flex-start", md: "center" }}
    spacing={2}
    sx={{
      p: { xs: 1.25, md: 1.5 },
      mb: 1.5,
      borderBottom: "1px solid",
      border: "1px solid",
      borderColor: (theme) => theme.palette.mode === "dark" ? "#2a3953" : "divider",
      borderRadius: 2,
      bgcolor: (theme) => theme.palette.mode === "dark" ? "#111b2d" : "background.paper",
    }}
  >
    <Box>
      <Stack direction="row" alignItems="center" spacing={1.5}>
        <Box sx={(theme) => ({ width: 32, height: 32, display: "grid", placeItems: "center", borderRadius: 1.5, bgcolor: theme.palette.mode === "dark" ? "rgba(59,130,246,.18)" : "primary.50", color: "primary.main" })}>
          <Warehouse size={18} />
        </Box>
        <Typography variant="h5" fontWeight={800}>
          Warehouse Operations
        </Typography>
      </Stack>
      <Typography color="text.secondary" variant="caption" mt={0.15}>
        Track requests, transfers, receipts, issues, service usage,
        and invoices.
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.2, fontSize: ".68rem" }}>
        Home&nbsp;&nbsp; / &nbsp;&nbsp;Warehouse&nbsp;&nbsp; / &nbsp;&nbsp;Operations
      </Typography>
    </Box>

    <Stack direction="row" gap={1} flexWrap="wrap" sx={{ width: { xs: "100%", md: "auto" } }}>
      <DataExportButton kind={filters.tab} filters={filters} disabled={loading} />
      <Button
        variant="outlined"
        startIcon={<RefreshCw size={18} />}
        onClick={onRefresh}
        disabled={loading}
      >
        Refresh
      </Button>
      <Button
        variant="contained"
        startIcon={<Plus size={18} />}
        onClick={onCreate}
        disabled={!canCreate}
        sx={{ flex: { xs: 1, md: "initial" } }}
      >
        New Operation
      </Button>
    </Stack>
  </Stack>
);

export default OperationsHeader;
